<template>
  <v-container fluid class="add-user fill-height">
    <v-layout class="div-center-horizontally">
      <v-flex xs12 sm12>
        <v-container class="medium-div">
          <v-layout row class="header-row">
            <v-flex class="div-center-vertically">
              <p v-if="userRegisterStep == 1" class="org-name">{{organization}}</p>
              <p v-else-if="userRegisterStep == 2" class="org-name"><a class="org-name-clickable" @click="userRegisterStep = 1">{{userData.name}} {{userData.lastName}}</a> / {{$t('AddUser.devices')}}</p>
              <p v-else-if="userRegisterStep == 3" class="org-name"><a class="org-name-clickable" @click="userRegisterStep = 1">{{userData.name}} {{userData.lastName}}</a> / <a class="org-name-clickable" @click="userRegisterStep = 2">{{$t('AddUser.devices')}}</a> / {{$t('AddUser.permissions')}}</p>
            </v-flex>
            <v-flex class="card-actions div-center-vertically div-right-horizontally">
              <p class="user-register-text">{{$t('AddUser.userRegister')}}</p>
              <v-btn @click="closeCard" icon class="close-icon">
                <v-icon color="#000000">close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row class="divider-row">
            <v-divider class="divider"/>
          </v-layout>
          <v-layout row class="user-content-row">
            <NewUser
              v-if="userRegisterStep == 1"
              :userRegisterStep.sync="userRegisterStep"
              :userData.sync="userData"
              :fromNewCampaign="fromNewCampaign"
              :originCampaignId="originCampaignId"
              :newCampaignStep="newCampaignStep"
              :fromNewField="fromNewField"
              :fromNewFieldData="fromNewFieldData"
            />
            <AssignDevices
              v-else-if="userRegisterStep == 2"
              :userRegisterStep.sync="userRegisterStep"
              :userData.sync="userData"
            />
            <PermissionsByDevice
              v-else-if="userRegisterStep == 3"
              :userData.sync="userData"
              :fromNewUser="true"
            />
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import NewUser from './AddUser/NewUser'
import AssignDevices from './AddUser/AssignDevices'
import PermissionsByDevice from './AddUser/PermissionsByDevice'

export default {
  components: {
    NewUser,
    AssignDevices,
    PermissionsByDevice
  },
  data () {
    const organization = this.$store.getters.userOrganization
    return {
      organization: this.$store.getters.userOrganization.name,
      userRegisterStep: 1,
      userData: {
        name: '',
        lastName: '',
        phone: '',
        role: '',
        organization: organization,
        editDataPermission: false,
        photoUrl: '',
        profilePic: '',
        devices: [],
        channels: ['push', 'whatsapp', 'sms'],
        notificationsPeriod: { startTime: '00:00', endTime: '23:59' }
      },
      fromNewCampaign: this.$route.params.fromNewCampaign || false,
      originCampaignId: this.$route.params.originCampaignId,
      newCampaignStep: this.$route.params.newCampaignStep,
      fromNewField: this.$route.params.fromNewField || false,
      fromNewFieldData: this.$route.params.fromNewFieldData || {}
    }
  },
  methods: {
    closeCard () {
      if (this.fromNewCampaign) {
        this.$router.push({name: 'NewCampaignInitialData', params: {campaignId: this.originCampaignId, step: this.newCampaignStep}})
        return
      } else if (this.fromNewField) {
        this.$router.push({name: 'AddField', params: { ...this.fromNewFieldData }})
        return
      }

      this.$router.push({name: 'OrganizationHome'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// AddUser.vue?c247fc86